import { render, staticRenderFns } from "./undangan-agenda-lainnya.vue?vue&type=template&id=7b0e5b90"
import script from "./undangan-agenda-lainnya.vue?vue&type=script&lang=js"
export * from "./undangan-agenda-lainnya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports